import { Box } from '@mui/material'

import OfuManageCampaignContainer from '~/features/campaigns/components/ofuManageCampaign'

function OfuManageCampaignPage() {
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <OfuManageCampaignContainer />
    </Box>
  )
}

export default OfuManageCampaignPage
